import type { QuestionnaireRevisionContext } from '@gcv/shared';

import { getLatestCompletedRevision } from './get-latest-completed-revision';

export const getEffectiveCompletedOn = (
  history: QuestionnaireRevisionContext[] | undefined,
  fallback: string | undefined
): string | undefined => {
  return getLatestCompletedRevision(history)?.completed_on ?? fallback;
};
